import CallIcon from "@mui/icons-material/Call";
import DraftsOutlinedIcon from "@mui/icons-material/DraftsOutlined";
import ImportExport from "@mui/icons-material/ImportExport";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import InfoCard from "component/_common/cards/infoCards";
import { formatDataUsage, formatPriceWithDelimiter } from "functions/helper";
import React from "react";
import { BuildBundleProps } from "_interfaces/phoneBooking";

interface Props {
  data?: BuildBundleProps | null;
}

const BuildBundleCard: React.FC<Props> = ({ data }) => {
  return (
    <>
      <Card
        sx={{
          backgroundColor: "#FFFFFF",
          boxShadow: "none",
          height: "100%",
          display: "flex",
          flexDirection: "column",
        }}
        className="fm-poppins"
      >
        <CardContent
          sx={{
            padding: "0 !important",
          }}
        >
          <Box>
            <InfoCard
              Icon={ImportExport}
              heading={
                data?.unit?.dataMb ? formatDataUsage(data?.unit?.dataMb) : "0"
              }
              desc="DATA"
              value={
                data?.price?.dataPrice
                  ? `UGX ${formatPriceWithDelimiter(data?.price?.dataPrice)}`
                  : "0"
              }
            />

            <InfoCard
              Icon={CallIcon}
              heading={data?.unit?.onNetVoice || "0"}
              desc="On Net Voice"
              value={
                data?.price?.onNetPrice
                  ? `UGX ${formatPriceWithDelimiter(data?.price?.onNetPrice)}`
                  : "0"
              }
            />

            <InfoCard
              Icon={CallIcon}
              heading={data?.unit?.offNetVoice || "0"}
              desc="All Net Voice"
              value={
                data?.price?.offNetPrice
                  ? `UGX ${formatPriceWithDelimiter(data?.price?.offNetPrice)}`
                  : "0"
              }
            />

            <InfoCard
              Icon={DraftsOutlinedIcon}
              heading={data?.unit?.smsOffNet || "0"}
              desc="SMS"
              value={
                data?.price?.smsPrice
                  ? `UGX ${formatPriceWithDelimiter(data?.price?.smsPrice)}`
                  : "0"
              }
            />
          </Box>
        </CardContent>
      </Card>
    </>
  );
};

export default BuildBundleCard;
